import React from 'react';
import { roundFloat } from 'src/core/utils/formater';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';

// Импорт: Нэг газраас
import { huuliData } from 'src/data/huuliData';
import { yamList } from 'src/data/yamsData';

/* -------------------------------------------------------------------------- */
/*  Mapping of “Төрөл” (type) codes                                            */
/* -------------------------------------------------------------------------- */
const types = {
  1: '1.хөрөнгө оруулалт',
  2: '2.санхүүгийн дэмжлэг',
  3: '3.хандив',
};

/* -------------------------------------------------------------------------- */
/*  Хуулийн дугаар → 22.9.x болгох                                          */
/* -------------------------------------------------------------------------- */
const getHuuliKey = (id) => huuliData[id]?.key || id;

/* -------------------------------------------------------------------------- */
/*  Яамны ID → Нэр болгох                                                   */
/* -------------------------------------------------------------------------- */
const getYamNames = (yamStr) => {
  if (!yamStr) return '';
  return yamStr
    .split(',')
    .map((y) => y.trim())
    .filter(Boolean)
    .map((y) => yamList[y] || y)
    .join(', ');
};

/* -------------------------------------------------------------------------- */
/*  Custom summary row                                                       */
/* -------------------------------------------------------------------------- */
export const customSummary = [
  { value: null },
  { align: 'left', word: 'Нийт дүн:' },
  { value: null },
  { value: null },
  { value: null },
  { value: null },
  { value: null },
  { value: null },
  { value: null },
  { align: 'right', value: 'total_total_dun' },
  { align: 'right', value: 'total_tai_dun' },
  { value: null },

  { value: null },
  { value: null },
];

/* -------------------------------------------------------------------------- */
/*  Table column definition                                                   */
/* -------------------------------------------------------------------------- */
export const customColumns = ({
  customDelete = () => {},
  customEdit = () => {},
}) => [
  {
    title: 'Д/Д',
    dataIndex: 'counter',
    align: 'center',
    titleAlign: 'center',
    width: 50,
  },

  {
    title:
      'Элэгдэл тооцох үндсэн хөрөнгөд оруулсан хөрөнгө оруулалт, харилцан хамааралгүй бусад этгээдэд олгосон санхүүгийн дэмжлэг, хандивын',
    titleAlign: 'center',
    children: [
      {
        title: 'хүлээн авсан этгээд',
        titleAlign: 'center',
        children: [
          {
            title: 'ТТД',
            dataIndex: 'ttd_avsan',
            align: 'left',
            titleAlign: 'center',
            width: 80,
          },
          {
            title: 'Нэр',
            dataIndex: 'ner_avsan',
            align: 'left',
            titleAlign: 'center',
            width: 120,
          },
        ],
      },
      {
        title: 'Огноо',
        dataIndex: 'ognoo',
        align: 'center',
        titleAlign: 'center',
        width: 100,
      },
      {
        title: 'төлбөрийн баримтын дугаар',
        dataIndex: 'tulbur_dugaar',
        align: 'center',
        titleAlign: 'center',
        width: 140,
      },
      {
        title: 'Төрөл',
        dataIndex: 'turul',
        align: 'center',
        titleAlign: 'center',
        width: 120,
        render: (val) => types[val] || val,
      },
      {
        title: 'Зориулалт',
        dataIndex: 'zoriulalt',
        align: 'center',
        titleAlign: 'center',
        width: 150,
      },
    ],
  },

  /* ────────────────────── ХУУЛИЙН ЗААЛТ ────────────────────── */
  {
    title: 'Хуулийн заалт',
    titleAlign: 'center',
    children: [
      {
        title: 'Дугаар',
        dataIndex: 'huuli_dugaar',
        align: 'center',
        titleAlign: 'center',
        width: 100,
        render: (id) => getHuuliKey(id), // 1 → 22.9.1
      },
      {
        title: 'заалт',
        dataIndex: 'zaalt',
        align: 'left',
        titleAlign: 'center',
        width: 400, // Өргөтгөв
        render: (text, row) => {
          const item = huuliData[row.huuli_dugaar];
          const fullText = item?.text || text || '-';

          // 100 тэмдэгт эсвэл 2 мөр хүртэл харагдана
          const truncated =
            fullText.length > 100 ? `${fullText.slice(0, 100)}...` : fullText;

          return (
            <div
              style={{
                whiteSpace: 'normal',
                lineHeight: '1.4',
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
              title={fullText}
            >
              {truncated}
            </div>
          );
        },
      },
    ],
  },

  /* ────────────────────── НИЙТ ДҮН ────────────────────── */
  {
    title: 'Нийт дүн',
    dataIndex: 'total_dun',
    align: 'right',
    titleAlign: 'center',
    width: 180,
    render: (_, row) => roundFloat(row?.total_dun),
  },

  /* ────────────────────── ТАЙЛАНД ТУСГАСАН ────────────────────── */
  {
    title:
      'Санхүүгийн дэмжлэг хандивын зарцуулалт/ хүлээн авч санхүүгийн тайланд тусгасан үндсэн хөрөнгийн дүн',
    dataIndex: 'tai_dun',
    align: 'right',
    titleAlign: 'center',
    width: 180,
    render: (_, row) => roundFloat(row?.tai_dun),
  },

  /* ────────────────────── ХЯНАЛТ ТАВИХ ЯАМ ────────────────────── */
  {
    title: 'Хяналт тавих яам',
    dataIndex: 'yam',
    align: 'left',
    titleAlign: 'center',
    width: 200,
    render: (yamStr) => getYamNames(yamStr),
  },

  /* ────────────────────── ЗАСАХ ────────────────────── */
  {
    title: 'Засах',
    align: 'center',
    titleAlign: 'center',
    width: 60,
    render: (_, row) => (
      <EditOutlined
        style={{ cursor: 'pointer', color: '#1890ff', fontSize: '16px' }}
        onClick={(e) => {
          e.stopPropagation();
          customEdit(row);
        }}
        title="Засах"
      />
    ),
  },

  /* ────────────────────── УСТГАХ ────────────────────── */
  {
    title: 'Устгах',
    align: 'center',
    titleAlign: 'center',
    width: 60,
    render: (_, row) => (
      <DeleteOutlined
        style={{ cursor: 'pointer', color: '#ff4d4f', fontSize: '16px' }}
        onClick={(e) => {
          e.stopPropagation();
          customDelete(row);
        }}
        title="Устгах"
      />
    ),
  },
];
